import * as ng from 'angular';
import { ComponentRegistration } from '../core';
import {ISessionService, ISessionState} from "../services";
let template = require('./nav-bar.html');

class NavBarComponent extends ComponentRegistration {

    constructor() {
        super('navBar', {
            controller: NavBarController,
            templateUrl: template,
            controllerAs: 'navBar',
            bindings: {
                selected: '@'
            }
        });
    }
}



interface INavBarController {
    isSelected(index): Boolean;
    onNavClick(index): void;
    isReservedParkingAccount: Boolean;
}

class NavBarController implements INavBarController {
    public static $inject: Array<string> = ['$rootRouter', 'Session'];

    //private fields
 
    //bindings
    private selected: any;

    private session: ISessionState;

    constructor(private $rootRouter:ng.Router, private Session: ISessionService) {
        console.log('NavBarController activated');
    }

    public $onInit(): void {

        let self = this;
        this.Session.getSessionAsync()
            .then((session) => {
                self.session = session;
            }).catch((e) => {
                console.error(e);
                console.error('Failed to load session data. Some tabs might not show up or might miss-function.');
            });

        console.log('NavBarController loaded');
    }

    public get isReservedParkingAccount() : Boolean {
        return  this.session && this.session.account && this.session.account.isReservedParking;
    }

    public isSelected(index): Boolean {
        return index === this.selected;
    }

    public onNavClick(index): void {
        this.selected = index;
        this.$rootRouter.navigate([index]);
    }

}

let nbarComponent = new NavBarComponent();
export default nbarComponent;
export { nbarComponent as NavBarComponent, INavBarController, NavBarController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/user-controls/nav-bar.ts